import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const mediaUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const money = (n) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" }).format(Number(n || 0));

// Derive the shopper-facing price view: sale (now) vs regular (was), % off, savings, and an
// optional secondary "Retail" reference. An item is on sale only when sale_price < regular price.
export const priceView = (p) => {
  const price = Number(p?.price) || 0;
  const rawSale = p?.sale_price;
  const sale = rawSale !== null && rawSale !== undefined && rawSale !== "" ? Number(rawSale) : null;
  const rawCmp = p?.compare_at_price;
  const compare = rawCmp !== null && rawCmp !== undefined && rawCmp !== "" ? Number(rawCmp) : null;
  const onSale = sale !== null && sale > 0 && sale < price;
  if (onSale) {
    return {
      onSale: true, now: sale, was: price, regular: price,
      pct: Math.round(((price - sale) / price) * 100), save: price - sale,
      retail: compare && compare > price ? compare : null,
    };
  }
  const hasCmp = compare && compare > price;
  return {
    onSale: false, now: price, was: hasCmp ? compare : null, regular: price,
    pct: hasCmp ? Math.round(((compare - price) / compare) * 100) : null,
    save: hasCmp ? compare - price : null, retail: null,
  };
};

export const savings = (price, compare) => {
  if (!compare || compare <= price) return null;
  return Math.round(((compare - price) / compare) * 100);
};
